/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Widget_Empty_LeadsInputs */

const cs_dashboard_widget_empty_leads = /** @type {(inputs: Dashboard_Widget_Empty_LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné nové leady.`)
};

const en_dashboard_widget_empty_leads = /** @type {(inputs: Dashboard_Widget_Empty_LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No recent leads.`)
};

/**
* | output |
* | --- |
* | "No recent leads." |
*
* @param {Dashboard_Widget_Empty_LeadsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_widget_empty_leads = /** @type {((inputs?: Dashboard_Widget_Empty_LeadsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Widget_Empty_LeadsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_widget_empty_leads(inputs)
	return cs_dashboard_widget_empty_leads(inputs)
});